import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { DisbursementsRegisterSection } from '@/features/reports/disbursements-register'

/** The disbursements register, as an addressable screen of its own. */
export function ReportsDisbursementsPage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Disbursements register"
        description="Rounds disbursed in a range, with what actually paid out net of fees and any security deposit taken up front."
      />

      <DisbursementsRegisterSection />
    </>
  )
}
